/**
 * Form types
 * Defined in FormType.java
 */
const formType = {
    FORM: 'form',
    FOLDER: 'folder',
    PAGE: 'page',
    DIALOG: 'dialog',
    NAVIGATION_TABS: 'navigation-tabs'
}

export default formType

formType.__filename__ = 'forms/model/form-type.js'
